import {
  RainbowKitProvider,
  darkTheme,
  getDefaultConfig,
} from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import {
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  safeWallet,
  walletConnectWallet,
  zerionWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { Buffer } from 'buffer';
import { WagmiProvider } from 'wagmi';
import { arbitrum, mainnet, optimism, polygon, base } from 'wagmi/chains';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  PhantomWalletAdapter,
  CoinbaseWalletAdapter,
  SolflareWalletAdapter,
  LedgerWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { useMemo } from 'react';

require('@solana/wallet-adapter-react-ui/styles.css');

window.global = window.global ?? window;
window.Buffer = window.Buffer ?? Buffer;
window.process = window.process ?? { env: {} }; // Minimal process polyfill

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const configuredMainnet = {
  ...mainnet,
  rpcUrls: {
    default: {
      http: [
        `https://eth-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_ID}`,
      ],
    },
    public: {
      http: [
        `https://eth-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_ID}`,
      ],
    },
  },
};

const config = getDefaultConfig({
  appName: 'Fractal Payments',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,
  chains: [configuredMainnet, polygon, optimism, arbitrum, base],
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [
        zerionWallet,
        walletConnectWallet,
        metaMaskWallet,
        injectedWallet,
        coinbaseWallet,
        safeWallet,
      ],
    },
  ],
});

export const WalletConfig = ({ children }) => {
  const solanaWallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new CoinbaseWalletAdapter(),
      new SolflareWalletAdapter({ network: WalletAdapterNetwork.Mainnet }),
      new LedgerWalletAdapter(),
    ],
    []
  );

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: '#4f46e5',
            accentColorForeground: '#ffffff',
          })}>
          <ConnectionProvider endpoint="https://solana-mainnet.g.alchemy.com/v2/wgnMXBCMIJddxM0ALNPEUVOIhyoiFs5Y">
            <WalletProvider wallets={solanaWallets}>
              <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
          </ConnectionProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};
